export default __webpack_public_path__ + "static/media/house-solid.f1769450.svg";